import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";

import Cuotas from "./CobranzasContent/Cuotas";
import EstDeudas from "./CobranzasContent/EstDeudas";
import SecDeudas from "./CobranzasContent/SecDeudas";
import Deserciones from "./CobranzasContent/Deserciones";
import CobroEspecial from "./CobranzasContent/CobroEspecial";

class Cobranzas extends Component {
    state = {
        valorOpcion: { value: 'cuotas', label: 'Cobro de Cuotas' },
    }

    Selecciona = (link) => {
        switch (link) {
            case "/cobranzas/cuotas":
                return({ value: 'cuotas', label: 'Cobro de Cuotas' })
            case "/cobranzas/cobro_especial":
                return({ value: 'cobro_especial', label: 'Cobros Especiales' })
            case "/cobranzas/est_deudas":
                return({ value: 'est_deudas', label: 'Estudiantes con Deudas' })
            case "/cobranzas/sec_deudas":
                return({ value: 'sec_deudas', label: 'Deuda por Sección' })
            case "/cobranzas/retiros":
                return({ value: 'retiros', label: 'Retiros y Deserciones' })
            default:
                return({ value: 'cuotas', label: 'Cobro de Cuotas' })
        }
    }

    valorEstadosLabel = (link) => {
        switch (link) {
            case "/cobranzas/cuotas": return('Cobro de Cuotas')
            case "/cobranzas/cobro_especial": return('Cobros Especiales')
            case "/cobranzas/est_deudas": return('Estudiantes con Deudas')
            case "/cobranzas/sec_deudas": return('Deuda por Sección')
            case "/cobranzas/retiros": return('Retiros y Deserciones')
            default: return('Cobro de Cuotas')
        }
    }

    valorActividad = (valorActividad) => {
        this.setState({
            valorActividad
        },() => {
            this.props.history.push(`/cobranzas/${this.state.valorActividad.value}`);
        });
    }

    contenido = () => {
        return (
            <Switch>
                <Route path="/cobranzas/cuotas" component={ () => <Cuotas/> } />
                <Route path="/cobranzas/cobro_especial" component={ () => <CobroEspecial/> } />
                <Route path="/cobranzas/est_deudas" component={ () => <EstDeudas /> } />
                <Route path="/cobranzas/sec_deudas" component={ () => <SecDeudas /> } />
                <Route path="/cobranzas/retiros" component={ () => <Deserciones /> } />
                <Redirect to = "/cobranzas/cuotas" />
            </Switch>
        )
    }

    render() { 
        const Opciones = [
            { value: 'cuotas', label: 'Cobro de Cuotas' },
            { value: 'cobro_especial', label: 'Cobros Especiales' },
            { value: 'est_deudas', label: 'Estudiantes con Deudas' },
            { value: 'sec_deudas', label: 'Deuda por Sección' },
            { value: 'retiros', label: 'Retiros y Deserciones' },
        ];

        return (
            <div className="content">
                <Grid fluid>
                    <div className="custom-alert-info" style={{marginBottom:15, padding:5}}>
                        <Row>
                            <Col md={9}>
                                <div className="title" style={{fontSize:14, paddingTop: 10}}>
                                    Selecciona una actividad
                                </div>
                            </Col>
                            <Col md={3}>
                                <Select
                                    isSearchable ={true}
                                    value={this.Selecciona(this.props.history.location.pathname)}
                                    onChange={this.valorActividad}
                                    options={Opciones}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={12}>
                            <CustomCard
                                title={`${this.valorEstadosLabel(this.props.history.location.pathname)}`}
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
 
export default Cobranzas;


// WEBPACK FOOTER //
// ./src/views/Administracion/Cobranzas.jsx